import { useCallback, useEffect } from "react"
import { useCreateChatClient } from "stream-chat-react"
import { useChatCountsStore } from "./useChatCountStore"

const apiKey = process.env.NEXT_PUBLIC_STREAM_CHAT_API_KEY!

// This updater should only be used once in the app
export const useChatCountsUpdater = ({ uuid, messagingToken }: { uuid: string; messagingToken: string }) => {
  const chatClient = useCreateChatClient({
    apiKey,
    tokenOrProvider: messagingToken,
    userData: { id: uuid },
  })

  const { setUnreadCount } = useChatCountsStore()

  const updateUnreadChatCounts = useCallback(async () => {
    if (!chatClient) {
      return
    }
    const response = await chatClient?.getUnreadCount()
    const unreadCount = response?.total_unread_count

    if (typeof unreadCount === "number") {
      setUnreadCount(unreadCount)
    }
  }, [chatClient, setUnreadCount])

  useEffect(() => {
    if (!uuid || !chatClient) {
      return
    }

    // Update on mount
    updateUnreadChatCounts()

    // Subscribe to chat events
    const chatClientEvents = chatClient?.on(async event => {
      if (
        event.type === "notification.message_new" ||
        event.type === "notification.mark_read" ||
        event.type === "message.new" ||
        event.type === "message.read"
      ) {
        await updateUnreadChatCounts()
      }
    })

    return () => {
      chatClientEvents.unsubscribe()
    }
  }, [chatClient, updateUnreadChatCounts, uuid])
}
